import { useContext } from 'react'
// import Context from 'store/Context'
import { StateContext, DispatchContext } from 'store/Context'

export const useStore = () => {
  const state = useContext(StateContext)
  const dispatch = useContext(DispatchContext)
  return { state, dispatch }
}
